import { ChatIcon32, cn } from '@repo/ui'
import RouterLink from './RouterLink'
import { useZugnummerStore } from '@/store/useZugnummerStore'
import { useShallow } from 'zustand/react/shallow'
import { ID_RELEVANT_BFNS } from '@/features/befehlsnachrichten/pages/BfnOverview'
import useBfnOverviewEntries from '@/features/befehlsnachrichten/hooks/useBfnOverviewEntries'
import { BfnStatus } from '@/models/Befehlsnachricht'

export interface RelevantBfnsDisplayProps {
  'data-testid': string
}

export default function RelevantBfnsDisplay({
  'data-testid': testId
}: Readonly<RelevantBfnsDisplayProps>) {
  const zugnummer = useZugnummerStore(useShallow((state) => state.zugnummer))
  const { relevantEntries } = useBfnOverviewEntries(zugnummer)
  const relevantGueltigeEntries = relevantEntries.filter(
    ([, entry]) => entry.befehlsnachricht.status === BfnStatus.QUITTIERT
  )
  if (!zugnummer) return null

  return (
    <>
      {zugnummer && (
        <>
          <span
            className="w-px self-stretch bg-cool-gray-800 dark:bg-cool-gray-200"
            data-testid={`${testId}-divider`}
          />
          <RouterLink
            to="/"
            state={{ scrollTo: ID_RELEVANT_BFNS }}
            className="group inline-block relative dark:active:text-cool-gray-200 dark:hover:text-cool-gray-300"
            data-testid={`${testId}-link`}
          >
            <ChatIcon32 data-testid={`${testId}-icon`} />
            {relevantGueltigeEntries.length > 0 && (
              <div
                className={cn(
                  'inline-flex items-center justify-center font-semibold text-nowrap',
                  'bg-light-green-500 text-white dark:bg-light-green-600',
                  'group-hover:bg-light-green-400  dark:group-hover:bg-light-green-700',
                  'absolute top-0 right-0 translate-x-1/3 -translate-y-1/3',
                  'rounded-full min-w-1.5 min-h-1',
                  relevantGueltigeEntries.length > 9 && 'px-0.375'
                )}
                data-testid={`${testId}-indicator`}
              >
                <span data-testid={`${testId}-text`}>
                  {relevantGueltigeEntries.length}
                </span>
              </div>
            )}
          </RouterLink>
        </>
      )}
    </>
  )
}
